import { useLocation } from 'react-router-dom';
import { REGISTRATION_SOURCE } from '@/common/functions/getUtms';
import { useGuestAuth } from '@/common/contexts/GuestAuthContext';
import { useAccountPlanGate } from '@/common/hooks/useAccountPlanGate';

export const useChatAccess = () => {
	const location = useLocation();
	const { isGuest, user, isAuthLoading, openAuthModal } = useGuestAuth();
	const accountGate = useAccountPlanGate(!isGuest && Boolean(user));

	const returnPath = `${location.pathname}${location.search}`;

	return {
		isGuest,
		isAuthLoading,
		isCheckingAccount:
			!isGuest && Boolean(user) && accountGate.isAccountChecking,
		isAccountActive: accountGate.isAccountActive,
		needsRegistration: isGuest && !isAuthLoading,
		needsPlan: accountGate.needsPlan,
		canChat: !isGuest && Boolean(user) && accountGate.isAccountActive === true,
		openRegister: () =>
			openAuthModal('register', returnPath, REGISTRATION_SOURCE.CHAT),
		openLogin: () => openAuthModal('login', returnPath),
		refreshAccountStatus: accountGate.refreshAccountStatus,
	};
};
